"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recursiveSearchToFlat = exports.flatSearchToRecursiveWithOR = exports.flatSearchToRecursive = void 0;
const flatSearchToRecursive = (search, mode) => {
    if (search.length === 0) {
        // Yes, this is a valid search
        return {};
    }
    const result = { and: [] };
    search.forEach((param) => {
        const key = mode === 'id' ? param.field.id : param.field.name;
        let { value, operator } = param;
        // In order to satisfy objectMatchesSearch which does not support not_empty
        // FieldOperator.empty must become { empty: true }
        // FieldOperator.notEmpty must become { empty: false }
        if (operator === "empty" /* FlatSearchFieldOperator.empty */) {
            value = typeof value === 'boolean' ? value : true;
        }
        else if (operator === "not_empty" /* FlatSearchFieldOperator.notEmpty */) {
            operator = "empty" /* FlatSearchFieldOperator.empty */;
            value = typeof value === 'boolean' ? !value : false;
        }
        result.and.push({ [key]: { [operator]: value } });
    });
    return result;
};
exports.flatSearchToRecursive = flatSearchToRecursive;
const flatSearchToRecursiveWithOR = (search, mode) => {
    if (search.length === 0) {
        return {};
    }
    return {
        or: search.map((andComponent) => {
            return (0, exports.flatSearchToRecursive)(andComponent, mode);
        }),
    };
};
exports.flatSearchToRecursiveWithOR = flatSearchToRecursiveWithOR;
const reversedOperators = new Map([
    ['eq', 'not_eq'],
    ['not_eq', 'eq'],
    ['gte', 'lt'],
    ['gt', 'lte'],
    ['lte', 'gt'],
    ['lt', 'gte'],
    ['before', 'after'],
    ['after', 'before'],
    ['like', 'not_like'],
    ['not_like', 'like'],
    ['in', 'not_in'],
    ['not_in', 'in'],
]);
const recursiveSubsearchToFlat = (search, fieldMap, operatorMode) => {
    const flatSearch = [];
    Object.keys(search).forEach((key) => {
        if (key === 'or') {
            // We're ignoring more complex structures for now
            return;
        }
        if (key === 'and') {
            search[key].forEach((subsearch) => {
                flatSearch.push(...recursiveSubsearchToFlat(subsearch, fieldMap, operatorMode));
            });
            return;
        }
        if (key === 'not') {
            flatSearch.push(...recursiveSubsearchToFlat(search[key], fieldMap, !operatorMode));
            return;
        }
        let operator = typeof search[key] !== 'object'
            ? 'eq'
            : Object.keys(search[key])[0];
        let value = typeof search[key] !== 'object'
            ? search[key]
            : search[key][Object.keys(search[key])[0]];
        if (operatorMode === false) {
            if (operator !== 'empty') {
                operator = reversedOperators.get(operator);
            }
            else {
                value = !value;
            }
        }
        if (fieldMap.has(key)) {
            flatSearch.push({
                field: fieldMap.get(key),
                operator,
                value,
            });
        }
    });
    return flatSearch;
};
const recursiveSearchToFlat = (search, mode, fields) => {
    const fieldMap = new Map(fields.map((f) => [mode === 'id' ? f.id : f.name, f]));
    return recursiveSubsearchToFlat(search, fieldMap, true);
};
exports.recursiveSearchToFlat = recursiveSearchToFlat;
